export default "__VITE_ASSET__Cl426cC$__"